import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";

import { IMsalContext } from "../../authentication/MsalContext";
import { useMsal } from "../../authentication/MsalProvider";
import { Auction, useAuction } from "../../services/AuctionService";
import { LoadingComponent } from "../loading/LoadingComponent";
import LotEndedView from "./lot-ended/LotEndedView";
import VehicleViewLot from "./vehicle-lot/VehicleViewLot";

interface VehicleAuctionContainerProps {
  auctionId: string;
}

const ViewLotComponent: React.FC<VehicleAuctionContainerProps> = ({ auctionId }) => {
  const msal: IMsalContext = useMsal();
  const { enqueueSnackbar } = useSnackbar();

  const [auction, auctionLoading] = useAuction(auctionId, msal.accounts.length > 0, () => {
    enqueueSnackbar('There was a problem loading the auction, please try again.', { variant: "error" });
  });



  const [auctionWithReg, setAuctionWithReg] = useState<Auction>();

  useEffect(() => {
    if (auction) {
      setAuctionWithReg({ ...auction });
    }
  }, [auction]);

  if (!auctionWithReg || auctionLoading) {
    return <LoadingComponent label="Loading Auction" />;
  }

  // If the auction is hidden, we want to show a message indicating this rather than the auction details.
  if (auctionWithReg.metadata.hidden) {
    return <LotEndedView auction={auctionWithReg} />;
  }

  return <VehicleViewLot auction={auctionWithReg} />;
};

export default ViewLotComponent;
